import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Свойство", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Операция", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Значение", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DateControl = _resolveComponent("DateControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog",
    height: '400px',
    onSaveData: _ctx.saveData
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_CatalogueSelectControl, {
          class: "ModelField-selectControl",
          stylingMode: "outlined",
          id: model.featureId,
          "onUpdate:id": ($event: any) => ((model.featureId) = $event),
          desc: model.featureDescription,
          "onUpdate:desc": ($event: any) => ((model.featureDescription) = $event),
          displayDescField: "name",
          keyField: "id",
          catalogueComponentName: "catalogues/FeatureCatalogue/FeatureCatalogue",
          hasEmptyValue: false,
          validationGroup: validationGroup,
          onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange(false)))
        }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_EnumControl, {
          class: "ModelField-control",
          id: model.operation,
          "onUpdate:id": ($event: any) => ((model.operation) = $event),
          desc: model.typeDescription,
          "onUpdate:desc": ($event: any) => ((model.typeDescription) = $event),
          enumType: "operationType",
          stylingMode: "outlined",
          displayedOperations: _ctx.displayedOperations
        }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "displayedOperations"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        (_ctx.isString || _ctx.isDataField)
          ? (_openBlock(), _createBlock(_component_DxTextBox, {
              key: 0,
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Значение...",
              "show-clear-button": true,
              value: _ctx.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event))
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_ctx.isInteger)
          ? (_openBlock(), _createBlock(_component_IntegerControl, {
              key: 1,
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Значение...",
              min: 0,
              step: 1,
              "show-spin-buttons": true,
              value: _ctx.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event))
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_ctx.isDecimal)
          ? (_openBlock(), _createBlock(_component_DecimalControl, {
              key: 2,
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Значение...",
              min: 0,
              step: 0.1,
              "show-spin-buttons": true,
              value: _ctx.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value) = $event))
            }, null, 8, ["step", "value"]))
          : _createCommentVNode("", true),
        (_ctx.isBoolean)
          ? (_openBlock(), _createBlock(_component_DxSelectBox, {
              key: 3,
              class: "ModelField-control",
              stylingMode: "outlined",
              items: ['True', 'False'],
              "show-clear-button": true,
              placeholder: "Значение...",
              value: _ctx.value,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value) = $event))
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_ctx.isDate)
          ? (_openBlock(), _createBlock(_component_DateControl, {
              key: 4,
              class: "ModelField-control",
              stylingMode: "outlined",
              value: _ctx.value,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value) = $event)),
              mode: "datetime",
              hasEmptyValue: false
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_ctx.isEnum)
          ? (_openBlock(), _createBlock(_component_EnumControl, {
              key: 5,
              class: "ModelField-control",
              id: _ctx.controlData.enumId,
              "onUpdate:id": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.controlData.enumId) = $event)),
              desc: _ctx.controlData.controlDescription,
              "onUpdate:desc": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.controlData.controlDescription) = $event)),
              enumType: _ctx.controlData.enumType,
              stylingMode: "outlined"
            }, null, 8, ["id", "desc", "enumType"]))
          : _createCommentVNode("", true),
        (_ctx.isCatalogue)
          ? (_openBlock(), _createBlock(_component_CatalogueSelectControl, {
              key: 6,
              class: "ModelField-selectControl",
              stylingMode: "outlined",
              id: _ctx.controlData.catalogueId,
              "onUpdate:id": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.controlData.catalogueId) = $event)),
              desc: _ctx.controlData.controlDescription,
              "onUpdate:desc": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.controlData.controlDescription) = $event)),
              displayDescField: "name",
              keyField: "id",
              catalogueComponentName: _ctx.controlData.cataloguePath,
              hasEmptyValue: true,
              validationGroup: validationGroup
            }, null, 8, ["id", "desc", "catalogueComponentName", "validationGroup"]))
          : _createCommentVNode("", true),
        (_ctx.isDCatalogue)
          ? (_openBlock(), _createBlock(_component_CatalogueSelectControl, {
              key: 7,
              class: "ModelField-selectControl",
              stylingMode: "outlined",
              id: _ctx.controlData.dCatalogueId,
              "onUpdate:id": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.controlData.dCatalogueId) = $event)),
              desc: _ctx.controlData.controlDescription,
              "onUpdate:desc": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.controlData.controlDescription) = $event)),
              displayDescField: "name",
              keyField: "id",
              catalogueComponentName: "catalogues/DCatalogueCatalogue/DCatalogueItemCatalogue",
              parentModel: _ctx.controlData.dCatalogueModel,
              hasEmptyValue: true,
              validationGroup: validationGroup
            }, null, 8, ["id", "desc", "parentModel", "validationGroup"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onSaveData"]))
}